import React, { useCallback } from 'react';
import { useAppDispatch } from '../../../redux/hooks';
import { closeModal } from '../../../redux/slices/modal';
import { useBootstrapSelector } from '../../../redux/selectorHooks';
import { assertNotNil } from '../../../utils/types';
import { IncidentCreateModal } from '../../../components/Incidents/IncidentModals';
import KubitModal from '../../../components/KubitModal';

const CreateIncidentModal = () => {
  const dispatch = useAppDispatch();

  const handleClose = useCallback(() => {
    dispatch(closeModal());
  }, [dispatch]);

  const defaultConfig = useBootstrapSelector('defaultConfig');
  assertNotNil(defaultConfig);
  const { defaultEnd } = defaultConfig;
  const today = new Date(defaultEnd);

  return (
    <KubitModal open={true} onClose={handleClose} maxWidth={550} noBodyWrapper>
      <IncidentCreateModal selectedStartDate={today} onClose={handleClose} />
    </KubitModal>
  );
};

export default CreateIncidentModal;
